<span>
    <ng-content select="[prefix]">
    </ng-content>
</span>

<span>{{ timeToDisplay }}</span>

<span>
    <ng-content select="[suffix]">
    </ng-content>
</span>
